import cn from 'classnames';
import { FCX } from "@datassential/platform-ui-lib";
import TableCellLoading from "@components/Table/TableCellLoading";
import { useTableColumnsContext } from "@components/Table/TableColumns";

const TableRowLoading: FCX = ({
    style,
    className,
    children,
}) => {
    const { data } = useTableColumnsContext();

    return (
        <div
            style={style}
            className={cn("TableRow", "TableRowLoading", className)}
        >
            {data.map(item => {
                const { style, key, } = item;

                return (
                    <TableCellLoading
                        key={key}
                        style={style?.cell}
                    />
                );
            })}
            {children}
        </div>
    );
}

export default TableRowLoading;